import { useLocale } from "../../../../hooks/useLocale";
import { msg } from "../../../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import { CreditCard, Gauge, Network, Percent } from "lucide-react";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { Sessions } from "src/view/forms/Sessions";
import { Fees } from "src/view/forms/Fees";
import { checkFeature, TAvailableFeatures } from "src/Featuresmap";
import { ITerminal } from "src/types/types";
import Spacer from "@ui/spacer/Spacer";
import { Informer } from "@ui/informer/Informer";
import { useTheme } from "styled-components";
import { ITheme } from "@ui/theme/GlobalTheme";
import { Typo } from "@ui/text/Typo";
import { MerchantTerminalChannels } from "src/view/conponents/list/MerchantTerminalChannels";

export const MerchantTerminalPage = () => {
	useLocale();
	const router = useRouter();

	const terminalId = parseInt(router.currentParams.tid ?? 0);
	const merchantId = parseInt(router.currentParams.mid ?? 0);
	const clientId = parseInt(router.currentParams.cid ?? 0);

	const [terminalReq, _1, _2, busy] = GD.REQ_MERCHANT_TERMINAL.useRequest(undefined, {
		merchantID: parseInt(router.currentParams.mid ?? 0),
		terminalLinkID: terminalId,
	});

	const terminal = terminalReq?.data ?? null;

	return (
		<Page sectionRightContent={null}>
			{busy && <Spinner />}
			<Error error={terminalReq?.error} />
			{terminal && (
				<VBox sx={{ gap: "20px", padding: "10px" }}>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						<TabItem title={msg("overview")} icon={<Gauge size={16} />}>{<OverviewMerchantTerminal terminal={terminal} />}</TabItem>

						<TabItem title={msg("channels")} icon={<Network size={16} />}>
							<MerchantTerminalChannels
								// clientId={groupReq.data.client_id}
								merchantId={merchantId}
								clientId={clientId}
								terminalId={terminal.id}
							/>
						</TabItem>

						<TabItem title={msg("fees_6d80486c")} icon={<Percent size={16} />}>
							<Fees target_id={terminal.link_id} target_type="merchant_terminal" parent_target_id={terminal.id} />
						</TabItem>

						<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
							<Sessions target_id={terminal.id} target_type="merchant_terminal" />
						</TabItem>
					</Tabs>
				</VBox>
			)}
		</Page>
	);
};

const OverviewMerchantTerminal = ({ terminal }: { terminal: ITerminal }) => {
	useLocale();
	const theme = useTheme() as ITheme;

	return (
		<Box>
			<Spacer size="30px" />
			<Informer
				title={msg("info_170322a3")}
				content={
					<Box
						sx={{
							display: "grid",
							gap: "12px",
							columnGap: "20px",
							gridTemplateColumns: "auto 1fr",
						}}>
						<Typo color={theme.colors.textSecondary}>{msg("name")}</Typo>
						<Typo>{terminal.name}</Typo>

						<Typo color={theme.colors.textSecondary}>{msg("status")}</Typo>
						<Typo>{terminal.status}</Typo>
					</Box>
				}></Informer>
		</Box>
	);
};
